import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useParticipanteTrilhaStatusService() {
  const { authenticatedFetch } = useApi();
  const cleanPayload = (obj = {}) =>
    Object.fromEntries(
      Object.entries(obj).filter(([, v]) => v !== null && typeof v !== 'undefined' && v !== '')
    );

  const upsertParticipanteTrilhaStatus = async (dados) => {
    // dados esperados:
    // {
    //   idParticipanteTurma: string (hash),
    //   idTrilha: string (hash),
    //   status?: 'nao_iniciada' | 'em_andamento' | 'concluida',
    //   percentual?: number
    // }
    const response = await authenticatedFetch(URLS.UPSERT_PARTICIPANTE_TRILHA_STATUS, {
      method: 'POST',
      body: JSON.stringify(dados),
    });

    return response.json();
  };

  const setStatusEPercentual = async (dados) => {
    // dados esperados: { idParticipanteTurma: string, idTrilha: string, status: string, percentual: number }
    const response = await authenticatedFetch(URLS.SET_PARTICIPANTE_TRILHA_STATUS_AND_PERCENTUAL, {
      method: 'POST',
      body: JSON.stringify(cleanPayload(dados)),
    });

    return response.json();
  };

  const marcarTrilhaEmAndamento = async (dados) => {
    // dados esperados: { idParticipanteTurma: string, idTrilha: string }
    const response = await authenticatedFetch(URLS.MARK_PARTICIPANTE_TRILHA_EM_ANDAMENTO, {
      method: 'POST',
      body: JSON.stringify(dados),
    });

    return response.json();
  };

  const marcarTrilhaConcluida = async (dados) => {
    // dados esperados: { idParticipanteTurma: string, idTrilha: string }
    const response = await authenticatedFetch(URLS.MARK_PARTICIPANTE_TRILHA_CONCLUIDA, {
      method: 'POST',
      body: JSON.stringify(dados),
    });

    return response.json();
  };

  const marcarTrilhaNaoIniciada = async (dados) => {
    // dados esperados: { idParticipanteTurma: string, idTrilha: string }
    const response = await authenticatedFetch(URLS.MARK_PARTICIPANTE_TRILHA_NAO_INICIADA, {
      method: 'POST',
      body: JSON.stringify(dados),
    });

    return response.json();
  };

  const obterTrilhaStatusPorId = async (id) => {
    const response = await authenticatedFetch(URLS.READ_PARTICIPANTE_TRILHA_STATUS_BY_ID, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const obterTrilhaStatusPorParticipanteTurmaETrilha = async (idParticipanteTurma, idTrilha) => {
    const response = await authenticatedFetch(
      URLS.READ_PARTICIPANTE_TRILHA_STATUS_BY_PARTICIPANTE_TURMA_AND_TRILHA,
      {
        method: 'POST',
        body: JSON.stringify(cleanPayload({ idParticipanteTurma, idTrilha })),
      }
    );

    return response.json();
  };

  const listarTrilhasStatusPorParticipanteTurma = async (idParticipanteTurma) => {
    const response = await authenticatedFetch(
      URLS.READ_PARTICIPANTE_TRILHA_STATUS_BY_PARTICIPANTE_TURMA,
      {
        method: 'POST',
        body: JSON.stringify({ idParticipanteTurma }),
      }
    );

    return response.json();
  };

  const deletarTrilhaStatusPorId = async (id) => {
    const response = await authenticatedFetch(URLS.DELETE_PARTICIPANTE_TRILHA_STATUS_BY_ID, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const deletarTrilhaStatusPorParticipanteTurmaETrilha = async (idParticipanteTurma, idTrilha) => {
    const response = await authenticatedFetch(
      URLS.DELETE_PARTICIPANTE_TRILHA_STATUS_BY_PARTICIPANTE_TURMA_AND_TRILHA,
      {
        method: 'POST',
        body: JSON.stringify({ idParticipanteTurma, idTrilha }),
      }
    );

    return response.json();
  };

  return {
    upsertParticipanteTrilhaStatus,
    setStatusEPercentual,
    marcarTrilhaEmAndamento,
    marcarTrilhaConcluida,
    marcarTrilhaNaoIniciada,
    obterTrilhaStatusPorId,
    obterTrilhaStatusPorParticipanteTurmaETrilha,
    listarTrilhasStatusPorParticipanteTurma,
    deletarTrilhaStatusPorId,
    deletarTrilhaStatusPorParticipanteTurmaETrilha,
  };
}
